// Sign-in screen.
//
// One button. Access needs a Google account on the company domain and a
// provisioned, active user row. The messages below explain which of those failed
// without confirming to an outsider whether an address exists.

import { useSearchParams } from 'react-router-dom'
import { useAuth } from '../auth.jsx'
import { Notice } from '../components/ui/index.js'
import './signin.css'

const MESSAGES = {
  wrong_domain:
    'That Google account is not on the company domain. Sign in with your fastestlabs.com account.',
  not_provisioned: 'That account is not set up for this app yet. Ask an administrator to add you.',
  inactive: 'That account has been deactivated. Ask an administrator to turn it back on.',
  state_mismatch: 'The sign-in attempt expired or did not match. Try again.',
  canceled: 'Sign-in was canceled.',
  sign_in_failed: 'Sign-in could not be completed. Try again.',
}

export default function SignIn() {
  const [params] = useSearchParams()
  const { allowedDomain } = useAuth()

  const errorCode = params.get('error')
  const message = errorCode ? MESSAGES[errorCode] || MESSAGES.sign_in_failed : null

  // Carry the originally requested path through the sign-in round trip.
  const next = params.get('next')
  const signInHref = next ? `/auth/google?next=${encodeURIComponent(next)}` : '/auth/google'

  return (
    <>
      <div className="signin-wrap">
        <div className="signin-card">
          <div className="signin-kicker">Fas-Tes Franchise Systems</div>
          <h1>National Accounts Relationship Management</h1>
          <p className="muted">
            Sign in with your {allowedDomain} account. An administrator has to add you before your
            first sign-in.
          </p>

          {message ? (
            <Notice tone="bad" className="signin-notice">
              {message}
            </Notice>
          ) : null}

          {/* The official Sign in with Google button, light theme, drawn per
              Google's identity branding guidelines. Google's hosted component
              cannot load under this app's CSP, so the markup is local, but the
              geometry, colours, type and the four colour G are the published
              spec and must not be restyled. The href is unchanged: the same
              server side OAuth flow as before. */}
          <a className="gsi-button" href={signInHref}>
            <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
              <path
                fill="#EA4335"
                d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
              />
              <path
                fill="#4285F4"
                d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
              />
              <path
                fill="#FBBC05"
                d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
              />
              <path
                fill="#34A853"
                d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
              />
            </svg>
            Sign in with Google
          </a>
        </div>
      </div>
    </>
  )
}
